import { render, staticRenderFns } from "./list.vue?vue&type=template&id=35d16e35"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d16e35')) {
      api.createRecord('35d16e35', component.options)
    } else {
      api.reload('35d16e35', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=35d16e35", function () {
      api.rerender('35d16e35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/list.vue"
export default component.exports